const translations = {
    date: 'Date',
    drone: 'Drone',
    duration: 'Duration',
    location: 'Location',
    pilot: 'Pilot',
    spray: 'Spray',
    spread: 'Spread',
    startTime: 'Start Time',
    type: 'Type'
};

export default translations;
